import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  createFilterOptions,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear, SettingsInputCompositeOutlined } from "@mui/icons-material";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import moment from "moment";

import { color } from "../../StyleData/Config";
import { axiosPrivate } from "../../axios/axios";
import { masterAPI } from "../Masters/dataConfig";
import { DesktopDatePicker } from "@mui/lab";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { defaultInfo } from "../../ConfigInfo/Info";

const UserRegisterModel = ({ mode, handleCloseClick, editData }) => {
  const [loading, setLoading] = useState(false);
  const [site, setSiteId] = useState([]);
  const [org, setOrgId] = useState([]);
  const [roles, setRoleId] = useState([]);
  const [selRoleName,setSelRoleName]=useState((editData?.userRoleList?.length!==0&&mode==="Edit")?editData.userRoleList[0].roleName:"")
  const [person, setPersonId] = useState([]);
  const [personDetials, setPersonDetials] = useState([]);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);

  const isOraAdmin = siteInfoDetail?.roleId === defaultInfo.OrgAdmin.id;
  const eamAdmin= siteInfoDetail.roleId===defaultInfo.superAdmin.id

  // const filteredRoles = isOraAdmin
  //   ? roles.filter(
  //       (role) =>
  //         ![
  //           "Ora Admin",
  //           "Administrator",
  //           "SuperAdmin",
  //           "Worker",
  //           "Management",
  //           "Test",
  //         ].includes(role.name)
  //     )
  //   : roles;

  const OPTIONS_LIMIT = 10;
  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const link = masterAPI["organization"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false);
        setOrgId(res.data.result);
      })
      .catch((e) => {
        setOrgId([]);
        setLoading(false);
        console.log(e, "siteerror");
      });

    if (!eamAdmin) {
      getSite(siteInfoDetail.organizationId);
    }
    if (mode==="Edit"&&!eamAdmin) {
      getSite(editData.organizationId);
    }

    const roleLink = masterAPI["roles"].link;
    await axiosPrivate
      .get(`${roleLink}`)
      .then((res) => {
        setLoading(false);
        setRoleId(res.data.result);
      })
      .catch((e) => {
        setRoleId([]);
        setLoading(false);
        console.log(e, "roleerror");
      });
    const personLink =
      siteInfoDetail.roleId === defaultInfo.OrgAdmin.id
        ? masterAPI["person"].link
        : masterAPI["person"].getallForSystemAdmin;
    await axiosPrivate
      .get(`${personLink}`)
      .then((res) => {
        setLoading(false);
        setPersonId(res.data.result);
      })
      .catch((e) => {
        setPersonId([]);
        setLoading(false);
        console.log(e, "setPersonId");
      });
  };
  const getPersonDetials = async (id) => {
    const personDetailsLink =
      siteInfoDetail.roleName === "Ora Admin"
        ? masterAPI["person"].getByid
        : masterAPI["person"].getbyidAdmin;
    await axiosPrivate
      .get(`${personDetailsLink}/${id}`)
      .then((res) => {
        console.log("test", res.data.result);
        setLoading(false);
        setPersonDetials(res.data.result);
      })
      .catch((e) => {
        setPersonDetials([]);
        setLoading(false);
        console.log(e, "setPersonDetials");
      });
  };
  const getSite = async (id) => {
    const link = masterAPI["site"].getallByOrgid;
    await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => {
        setLoading(false);
        setSiteId(res.data.result);
      })
      .catch((e) => {
        setSiteId([]);
        setLoading(false);
        console.log(e, "siteerror");
      });
  };

  const initialValue = {
    password: mode === "Edit" ? editData.password : "",
    siteId: mode === "Edit" ? editData.siteId : null,
    personId: mode === "Edit" ? editData.personId : null,
    roleId:mode === "Edit" && editData.userRoleList.length > 0
        ? editData.userRoleList[0].roleId
        : null,
    restrictedView: mode === "Edit" ? (editData.restrictedView ?? false) : false,
    organizationId:siteInfoDetail.organizationId === defaultInfo.organization.id
        ? ""
        : mode === "Edit"
        ? editData.organizationId
        : siteInfoDetail.organizationId,
  };

  const onSubmit = async (value) => {
    const payLoad = {
      emailConfirmed: true,
      firstName: personDetials.personName,
      lastName: personDetials.personName,
      email: personDetials.email,
      phoneNumber: personDetials.mobileNo,
      siteId:value.organizationId===defaultInfo.organization.id?siteInfoDetail.siteId:value.siteId,
      ...value,
      restrictedView:value.restrictedView,
    };
    console.log("submit", payLoad);
    setLoading(true);
    const createLink = masterAPI["userManagement"].register;
    const updateLink = masterAPI["userManagement"].update;
    const roleUserMapLink = masterAPI["user"].addroletouser;
    const roleUpdateLink = masterAPI["user"].updateRoleToUser;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payLoad)
        .then((res) => {
          const rolePayload = {
            restrictedView:value.restrictedView,
            roleId: value.roleId,
            userId: res.data.id,
            siteId: payLoad.siteId,
            roleName: value.roleName,
            organizationId: value.organizationId,
          };
          return axiosPrivate.post(roleUserMapLink, rolePayload);
        })
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          toast.error(e.response.data.failureMessage)
          console.log(e, "registeruser");
        });
    } else {
      const updateAC = {
        id: editData.id,
        emailConfirmed: true,
        firstName: personDetials.personName
          ? personDetials.personName
          : editData.firstName,
        lastName: personDetials.personName
          ? personDetials.personName
          : editData.lastName,
        email: personDetials.email ? personDetials.email : editData.email,
        phoneNumber: personDetials.mobileNo
          ? personDetials.mobileNo
          : editData.phoneNumber,
        roleName: value.roleName
          ? value.roleName
          : editData.userRoleList[0].roleName,
        ...value,
        restrictedView: value.restrictedView,
      };
      console.log("updatePayLoad", updateAC);
      await axiosPrivate
        .put(`${updateLink}`, updateAC)
        .then((res) => {
          const roleUpdatePayload = {
            restrictedView:value.restrictedView,
            roleId: value.roleId,
            userId: res.data.id,
            siteId: value.siteId,
            roleName: value.roleName
              ? value.roleName
              : editData.userRoleList[0].roleName,
            organizationId: value.organizationId,
            id: editData.userRoleList[0].id,
          };
          console.log("updateRolePayLoad", roleUpdatePayload);
          return axiosPrivate.post(roleUpdateLink, roleUpdatePayload); //b5fb08cc-63f1-4f37-a932-f8435c2ca6a
        })
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "updateuser");
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          User Registeration
          {/* {mode === "Edit"?editData.statusName:"New Asset Status"} */}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik initialValues={initialValue} onSubmit={onSubmit}>
        {({ handleChange, setFieldValue, values, resetForm }) => (
          <Form>
            <Grid container spacing={"1rem"}>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Person
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={person.length === 0}
                  options={person}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) => option.personName}
                  value={person.find((p) => p.id === values.personId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setPersonDetials(value)
                      
                      setFieldValue("personId", value.id);
                      getSite(value.organizationId);
                      setFieldValue("organizationId", value.organizationId);
                      // getPersonDetials(value.id);
                    } else {
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="person"
                      placeholder="Select Person"
                      //  onChange={handleChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                            {/* {site.length===0 ? (
                                              <CircularProgress color="inherit" size={20} />
                                            ) : null} */}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              {/* <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  First Name
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="firstName"
                    placeholder="Enter First Name"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                Last Name
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="lastName"
                    placeholder="Enter Last Name"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid> */}
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Email
                </Typography>
                <Field
                  as={TextField}
                  InputProps={
                    {
                      readOnly:true
                    }
                  }
                  size={"small"}
                  type="text"
                  name="email"
                  value={
                    personDetials.email
                      ? personDetials.email
                      : mode === "Edit"
                      ? editData.email
                      : null
                  }
                  placeholder="Enter email"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
              {/* <Grid item xs={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                Phone Number
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="phoneNumber"
                    placeholder="Enter phoneNumber"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid> */}
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Password
                </Typography>
                <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                  name="password"
                  placeholder="Enter password"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                />
              </Grid>
                            <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Organization
                </Typography>
                <Autocomplete
                  value={
                    org.find(
                      (p) =>
                        p.id ===
                        (editData.organizationId ||
                          (siteInfoDetail.organizationId !== defaultInfo.organization.id
                            ? siteInfoDetail.organizationId
                            : personDetials.organizationId))
                    ) || null
                  }
                  fullWidth
                  filterOptions={filterOptions}
                  loading={org.length === 0}
                  options={org}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.organizationName || option
                  }
                  // freeSolo={!isOraAdmin}
                  readOnly
                  onChange={(event, value) => {
                    if (value !== null) {
                      getSite(value.id);
                      setFieldValue("organizationId", value.id);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                   
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="organizationId"
                      placeholder="Select Organization"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {org.length === 0 ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sx={{
                    display:isOraAdmin?"default":"none"}}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Site
                </Typography>
                <Autocomplete
                  key={values.siteId || "default"}
                  fullWidth
                  filterOptions={filterOptions}
                  loading={site.length === 0}
                  options={site}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    option.code + " - " + option.siteName || option
                  }
                  value={site.find((p) => p.id === values.siteId) || null}
                  freeSolo
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                      setFieldValue("siteId", value.id);
                    } else {
                      setFieldValue("siteId", null);
                    }
                  }}
                  onInputChange={(event, newInputValue) => {
                    console.log(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="siteId"
                      placeholder="Select Site"
                      variant="outlined"
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Role
                </Typography>
                <Autocomplete
                  fullWidth
                  filterOptions={filterOptions}
                  loading={roles.length === 0}
                  options={roles}
                  PaperComponent={CustomPaper}
                  getOptionLabel={(option) =>
                    eamAdmin
                      ? option.name
                      : option.licenceCount !== undefined && option.licenceCount !== null
                      ? `${option.name} (${option.licenceCount})`
                      : option.name
                  }
                  value={
                    roles.find((p) => p.id === values.roleId) || null
                  }
                  inputValue={selRoleName}
                  getOptionDisabled={(option)=>eamAdmin?(personDetials.organizationId===defaultInfo.organization.id?option.id===defaultInfo.OrgAdmin.id:option.id!==defaultInfo.OrgAdmin.id):false}
                  freeSolo
                  disabled={values.roleId===defaultInfo.OrgAdmin.id&&!eamAdmin}
                  onChange={(event, value) => {
                    console.log(value);
                    if (value !== null) {
                       if (value.licenceCount <= 0 && !eamAdmin) {
                              toast.warning("License Count Exceeded");
                              setFieldValue("roleId", null);
                              setFieldValue("roleName", "");
                              setSelRoleName("")
                            }else{
                              if(value.id === defaultInfo.OrgAdmin.id){
                                 setFieldValue("restrictedView", false); // Set restrictView as false
                              }
                      setFieldValue("roleId", value.id);
                      setFieldValue("roleName", value.name);
                      setSelRoleName(eamAdmin?value.name:value.name+"("+value.licenceCount+")")
                             }
                    }else{
                      setFieldValue("roleId", null);
                              setFieldValue("roleName", "");
                              setSelRoleName("")
                    }
                    // if (value.name === "Ora Admin") {
                    //   setFieldValue("siteId", null); // Set site as null
                    // }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="roleId"
                      placeholder="Select Role"
                      variant="outlined"
                      size="small"
                      onChange={(e)=>{setSelRoleName(e.target.value)}}
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              </Grid>
              {values.roleId && values.roleId !== defaultInfo.OrgAdmin.id && (
                <Grid item xs={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Restricted View
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={values.restrictedView}
                        onChange={(e) =>
                          setFieldValue("restrictedView", e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    // label={values.restrictedView ? "Enabled" : "Disabled"}
                  />
                </Grid>
              )}
              <Grid
                container
                item
                xs={12}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default UserRegisterModel;
